import { privateApi } from '../config/api';

export const MarketplaceService = {
  // Assets
  getAssets: async (params = {}) => {
    const response = await privateApi.get('/p2p/marketplace/assets/', { params });
    return response.data;
  },
  
  getAsset: async (assetId) => {
    const response = await privateApi.get(`/p2p/marketplace/assets/${assetId}/`);
    return response.data;
  },
  
  createAsset: async (assetData) => {
    const response = await privateApi.post('/p2p/marketplace/assets/create/', assetData);
    return response.data;
  },
  
  updateAsset: async (assetId, assetData) => {
    const response = await privateApi.put(`/p2p/marketplace/assets/${assetId}/`, assetData);
    return response.data;
  },
  
  deleteAsset: async (assetId) => {
    const response = await privateApi.delete(`/p2p/marketplace/assets/${assetId}/`);
    return response.data;
  },
  
  getAssetOrders: async (assetId) => {
    const response = await privateApi.get(`/p2p/marketplace/assets/${assetId}/orders/`);
    return response.data;
  },
  
  // Orders
  getOrders: async () => {
    const response = await privateApi.get('/p2p/marketplace/orders/');
    return response.data;
  },
  
  getOrder: async (orderId) => {
    const response = await privateApi.get(`/p2p/marketplace/orders/${orderId}/`);
    return response.data;
  },
  
  createOrder: async (orderData) => {
    const response = await privateApi.post('/p2p/marketplace/orders/create/', orderData);
    return response.data;
  },
  
  sellerConfirmDelivery: async (orderId, notes) => {
    const response = await privateApi.post(`/p2p/marketplace/orders/${orderId}/seller-confirm/`, { notes });
    return response.data;
  },
  
  buyerConfirmReceipt: async (orderId, notes) => {
    const response = await privateApi.post(`/p2p/marketplace/orders/${orderId}/buyer-confirm/`, { notes });
    return response.data;
  },
  
  cancelOrder: async (orderId) => {
    const response = await privateApi.post(`/p2p/marketplace/orders/${orderId}/cancel/`);
    return response.data;
  }
};

export default MarketplaceService;

